module.exports = __webpack_public_path__ + "img/teamImage.baba75a7.png";